export const sum = (series, selector) => {
  return series.reduce((acc, curr) => acc + selector(curr), 0)
}
